import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess20401Status: 'idle',
    startProcess20401Error: undefined as any,
    loadUserParamsProcess20401Status: 'idle',
    loadUserParamsProcess20401Error: undefined as any,

    process20401List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess20401 = createAsyncThunk('process20401Slice/startProcess20401', async ({ process20401 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess20401/`,
        prepareData(process20401),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess20401Status } = getState().process20401Slice
        return startProcess20401Status !== 'pending'
    }
})

export const loadUserParamsProcess20401 = createAsyncThunk('process20401Slice/loadUserParamsProcess20401', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess20401/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess20401Status } = getState().process20401Slice
        return loadUserParamsProcess20401Status !== 'pending'
    }
})

const Process20401Slice = createSlice({
    name: 'process20401Slice',
    initialState,
    reducers: {
        resetstartProcess20401: (state) => {
            state.job = undefined
            state.startProcess20401Error = undefined
        },
        resetstartProcess20401Error: (state) => {
            state.startProcess20401Error = undefined
        },
        resetloadUserParamsProcess20401: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess20401Error = undefined
        },
        resetloadUserParamsProcess20401Error: (state) => {
            state.loadUserParamsProcess20401Error = undefined
        },
        removeFromProcess20401ListById: (state, action) => {
            state.process20401List = state.process20401List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess20401ListByIds: (state, action) => {
            state.process20401List = state.process20401List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process20401List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess20401Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process20401List = []
            state.startProcess20401Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess20401.pending, (state) => {
            state.startProcess20401Status = 'pending'
            state.startProcess20401Error = undefined
        })
        builder.addCase(startProcess20401.fulfilled, (state, action) => {
            state.startProcess20401Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess20401.rejected, (state, action) => {
            state.startProcess20401Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess20401Error = action.error.message
            } else {
                state.startProcess20401Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess20401.pending, (state) => {
            state.loadUserParamsProcess20401Status = 'pending'
            state.loadUserParamsProcess20401Error = undefined
        })
        builder.addCase(loadUserParamsProcess20401.fulfilled, (state, action) => {
            state.loadUserParamsProcess20401Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess20401.rejected, (state, action) => {
            state.loadUserParamsProcess20401Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess20401Error = action.error.message
            } else {
                state.loadUserParamsProcess20401Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess20401,
    resetstartProcess20401Error,
    resetloadUserParamsProcess20401,
    resetloadUserParamsProcess20401Error,
    removeFromProcess20401ListById,
    removeFromProcess20401ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process20401Slice.actions
export default Process20401Slice.reducer
